export const APP_URL = import.meta.env.VITE_IMAGE_URL;
export const SECRET_KEY = import.meta.env.VITE_IMAGE_URL_APP_CAPTCHA_SITE_KEY;
export const REQUIRED = "Required";
